import { Route, Routes } from 'react-router-dom'
import { PATH } from '~/AppRoutes'
import { useCurrentUser } from '~/common'
import { LabelPage } from '~/modules/label/view'
import { AuthWrapped } from '~/modules/navigation/components'

export const LabelRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('LABEL_REQUESTS')
  return (
    <Routes>
      <Route path={PATH.OVERVIEW} element={<AuthWrapped component={LabelPage} canAccess={canAccess} />} />
    </Routes>
  )
}

export const labelLinks = {
  labelLink: () => PATH.OVERVIEW,
}
